import React from 'react';
import './styles/WelcomeCard.css';

const WelcomeCard = ({ usuario, total }) => {
  return (
    <div className="welcome-card">
      <div className="welcome-content">
        <h2 className="welcome-title">Hola  {usuario?.nombre} !</h2>
        <p className="welcome-description">
          Bienvenido a nuestra plataforma. ¡Es un placer conocerte!</p>
        <p className="welcome-stats">
          Actualmente tienes un total de <span className="sales-badge">{total}</span> ventas registradas
        </p>

        <div className="weather-info">
          <div className="temperature">
            <span className="temp-label"></span>
          </div>
          <div className="weather-status">
            <span className="weather-label"></span>
          </div>
        </div>
      </div>

      <div className="welcome-decoration-1"></div>
      <div className="welcome-decoration-2"></div>
      <div className="welcome-decoration-3"></div>

      <div className="eliza-character">
        <div className="character-body"></div>
        <div className="character-head"></div>
        <div className="character-hair"></div>
      </div>
    </div>
  );
};

export default WelcomeCard;